import React from 'react'
import { Routes, Route } from "react-router-dom";
//import { useRetorik } from '@davi/retorik-framework/dist/src/components/Contexts/RetorikContext'

import '@davi/retorik-framework/dist/index.modern.css'
import './styles/App.scss';

import { AmnProvider, useAmn } from './contexts/AmnContext'
import { AmnApp } from './components/AmnApp';
import { DataExporter } from './components/DataExporter';
import { HomePage } from './components/HomePage';
import { StorageHandler } from './components/StorageHandler';


const App = () => {
  
  return (
    // <CustomAgent config={retorikConfig}/>
    <AmnProvider>
      <Routes>
          <Route index element={<HomePage />} />
          <Route path="amn" element={<AmnApp />} />
          <Route path="export" element={<DataExporter />} />
      </Routes>
      <StorageHandler/>
  </AmnProvider>
    
  )
}

export default App
